module.exports = __webpack_public_path__ + "static/media/files-transit.0371f9a0.svg";